export default "/images/5f154b68c3101bca7fc7a30daa0b2eaf.avif";